





import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: {
        text: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        }
    }
})
export default class Warning extends Vue {
};
